// Angular
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingStateService {

  private _isLoading = signal<boolean>(false);      
  private _isClerkReviewLoading = signal<boolean>(false);
        
    setAppIsLoading(isLoading:boolean): void {
      this._isLoading.set(isLoading);
    }

    getAppIsLoading(): boolean {
      return this._isLoading();
    }         
      
    setClerkReviewLoading(isLoading:boolean): void {
      this._isClerkReviewLoading.set(isLoading);
      this._isLoading.set(isLoading);
    }

    getClerkReviewLoading(): boolean {
      return this._isClerkReviewLoading();
    }  
}
